export enum UpdatePasswordError {
  /** The server returns an undefined or internal error */
  UnknownError = 'UNKNOWN_ERROR',

  /** Wrong password provided */
  WrongPassword = 'WRONG_PASSWORD',
}
